import {
  formatArticleIdentifier,
  formatDate,
  groupBy,
  orderByCityList,
} from "../utility/common-methods";

import {
  GET_MORE_PRINT_FEEDS,
  SET_PRINT_FEEDS_FAILED,
  SET_PRINT_FEEDS_START,
  SET_PRINT_FEEDS_FINISH,
} from "../actions/actionTypes";

import { DATE_FORMATS, MAX_FEEDS_LIMIT } from "../constants/app-constant";

function sortingFunction(a, b) {
  var editionA = a.edition.trim().toUpperCase();
  var editionB = b.edition.trim().toUpperCase();
  if (editionA < editionB) {
    return -1;
  }
  if (editionA > editionB) {
    return 1;
  }
  return 0;
}
const formatData = (data) => {
  try {
    let newData = {};
    let allArticleIdentifier = [];
    Object.keys(data).forEach((topic) => {
      const topicData = data[topic];
      const { Print = [], Online = [] } = topicData;
      let newTopicData = topicData;
      const groupedPrintData = {};
      Print.forEach((d) => {
        const { headline, publication_id, publish_date } = d;
        const str = `${headline
          .toString()
          .trim()
          .toLowerCase()}_${publication_id}_${formatDate(
          publish_date,
          DATE_FORMATS.DDMMYYYY_dash
        )}`;
        groupedPrintData[str] = groupedPrintData[str]
          ? [...groupedPrintData[str], d]
          : [d];
      });
      let newGrpdPrintData = {};
      Object.keys(groupedPrintData).forEach((pData) => {
        let currentData = groupedPrintData[pData];
        currentData = orderByCityList(currentData);
        const currentDataIdentifiers = formatArticleIdentifier(currentData[0]);
        allArticleIdentifier.push(currentDataIdentifiers);
        newGrpdPrintData[pData] = currentData;
      });
      newTopicData = {
        TotalPrintArticles: Print.length,
        TotalOnlineArticles: Online.length,
        Print: groupedPrintData,
        Online,
      };
      const onlineArticleIdentifier = Online.map((e) =>
        formatArticleIdentifier(e)
      );
      allArticleIdentifier = [
        ...allArticleIdentifier,
        ...onlineArticleIdentifier,
      ];
      newData[topic] = newTopicData;
    });
    return { formattedData: newData, allArticleIdentifier };
  } catch (e) {
    return {
      formattedData: {},
      allArticleIdentifier: [],
    };
  }
};

const initialState = {
  printNewsFeeds: {
    isLoading: true,
    error: undefined,
    data: [],
    showMore: false,
  },
};

export const printFeedsReducer = (
  state = initialState,
  { type, data, error, isCancelled }
) => {
  switch (type) {
    case GET_MORE_PRINT_FEEDS:
      return {
        ...state,
        ...{
          printNewsFeeds: {
            isLoading: true,
            data: state.printNewsFeeds.data,
            groupedArticleData: state.printNewsFeeds.groupedArticleData,
          },
        },
      };
    case SET_PRINT_FEEDS_START:
      return {
        ...state,
        ...{ printNewsFeeds: { isLoading: true, data: [] } },
      };
    case SET_PRINT_FEEDS_FINISH: {
      const { formattedData, allArticleIdentifier } = formatData(data);
      return {
        ...state,
        printNewsFeeds: {
          isLoading: false,
          data: formattedData,
          allArticleIdentifier,
          groupedArticleData: data,
          showMore: data.length >= MAX_FEEDS_LIMIT,
        },
      };
    }

    case SET_PRINT_FEEDS_FAILED:
      return {
        ...state,
        printNewsFeeds: {
          isLoading: isCancelled ? true : false,
          error,
          data: state.printNewsFeeds.data || [],
          showMore: false,
        },
      };

    default:
      return state;
  }
};
